
import { MOBILE_BROWSER_REGEX, IE_BROWSER_REGEX } from './regex-utils';

export const isMobileDevice = () => window.navigator.userAgent.match(MOBILE_BROWSER_REGEX);

export const isInterentExplorerDevice = () => window.navigator.userAgent.match(IE_BROWSER_REGEX);
